export const Qualy = (reviews: any) => {
  let checkin = { cant: 0, qualy: 0 };
  let cleanliness = { cant: 0, qualy: 0 };
  let communication = { cant: 0, qualy: 0 };
  let location = { cant: 0, qualy: 0 };
  let price_quality = { cant: 0, qualy: 0 };
  let truthgulness = { cant: 0, qualy: 0 };

  let total: any = {
    prom: 0,
    "5": 0,
    "4": 0,
    "3": 0,
    "2": 0,
    "1": 0,
  };

  reviews.map((qualy: any) => {
    let number = "0";
    Object.keys(qualy).map((key) => {
      if (key == "checkin") {
        checkin.qualy = qualy[key] + checkin.qualy;
        checkin.cant++;
      }
      if (key == "cleanliness") {
        cleanliness.qualy = qualy[key] + cleanliness.qualy;
        cleanliness.cant++;
      }
      if (key == "communication") {
        communication.qualy = qualy[key] + communication.qualy;
        communication.cant++;
      }
      if (key == "location") {
        location.qualy = qualy[key] + location.qualy;
        location.cant++;
      }
      if (key == "price_quality") {
        price_quality.qualy = qualy[key] + price_quality.qualy;
        price_quality.cant++;
      }
      if (key == "truthgulness") {
        truthgulness.qualy = qualy[key] + truthgulness.qualy;
        truthgulness.cant++;
      }
    });

    number = String(
      Math.round(
        (price_quality.qualy +
          location.qualy +
          communication.qualy +
          checkin.qualy +
          truthgulness.qualy) /
          6
      )
    );

    total = {
      ...total,
      prom: total.prom + 1,
      [number]: total[number] + 1,
    };
  });

  return {
    checkin: checkin.qualy / checkin.cant,
    cleanliness: cleanliness.qualy / cleanliness.cant,
    communication: communication.qualy / communication.cant,
    location: location.qualy / location.cant,
    price_quality: price_quality.qualy / price_quality.cant,
    truthgulness: truthgulness.qualy / truthgulness.cant,
    total: total,
  };
};
